export const environment = {
    NAME: "production",
    API: "https://api.onsceneservices.com",
    TOKEN_KEY: 'oss-api-token',
    S3BUCKET: 'photo-capture-tester'
};
